import type { ClarificationToolName } from './ask-user-details.types';
import type { PendingToolApproval } from './tool-approval.types';

/** Its wait never times out, so a surface that drops it blocks the run. */
export const REQUEST_PROTECTED_ACTION_APPROVAL_TOOL_NAME =
  'request_protected_action_approval';

/** Mirrors the backend tool's ``category`` enum. */
export const PROTECTED_ACTION_CATEGORIES = [
  'prescribing',
  'destructive_ehr',
  'money_or_claim',
] as const;

export type ProtectedActionCategory = (typeof PROTECTED_ACTION_CATEGORIES)[number];

/**
 * ``kind`` picks the card a child-run surface renders. It is derived from the
 * tool name, not ``approvalKind``: ``computer_use`` also covers plan and
 * file-task approvals, and live events arrive before ``approvalKind`` hydrates.
 */
export type ChildRunApproval =
  | (PendingToolApproval & {
      kind: 'clarification';
      toolName: ClarificationToolName;
    })
  | (PendingToolApproval & {
      kind: 'protected_action';
      toolName: typeof REQUEST_PROTECTED_ACTION_APPROVAL_TOOL_NAME;
    });

export type ProtectedActionChildRunApproval = Extract<
  ChildRunApproval,
  { kind: 'protected_action' }
>;
